import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";

import { resetALL } from "../../../../../.globals/redux/actions";

//STATE INITIAL
const INIT_STATE = {
  error: null,
  loading: false,
  items: [],
  total: 0,
  dataExport: null
};

const route = "modules/manage/views/cameraManagement/redux/slice";

export const cameraManagementSearchUnits = createAsyncThunk(
  "manage/cameraManagementSearchUnits",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue, dispatch }) => {
    try {
      const response = await clientQuery(
        cameraManagementSearchUnits.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "cameraManagementSearchUnits");
      return rejectWithValue(exc);
    }
  }
);

cameraManagementSearchUnits.query = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                data: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        linkedMode
                        linkedUnitId
                        linkedUnit {
                            id
                            label
                        }
                        timeZone {
                            id
                            name
                        }
                        maintenanceWarningEventsCount
                        sdCard
                        isOffline
                        deviceModel {
                            name
                            manufacturer {
                                name
                            }
                        }
                    }
                    total
                }
            }
            `;

const cameraManagementTabRedux = createSlice({
  name: "manage/cameraManagementTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);
    //cameraManagementSearchUnits
    builder.addCase(cameraManagementSearchUnits.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(cameraManagementSearchUnits.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(cameraManagementSearchUnits.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = cameraManagementTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;
